import React from "react";
import { Modal } from "react-bootstrap";
import {
  FiX,
  FiGift,
  FiCheck,
  FiCheckCircle,
  FiUsers,
  FiStar,
  FiPhoneCall,
  FiArrowUpRight,
} from "react-icons/fi";
import { HiSparkles } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";
import voucherLogo from "assets/images/new-logol.svg";
import voucherQr from "assets/images/pte-voucher-qr.svg";
import "./PteVoucherPopup.css";

// WhatsApp claim target — +91 90566 11913 with a prefilled enquiry message.
const WHATSAPP_NUMBER = "919056611913";
const WHATSAPP_MESSAGE =
  "Hello, can I get the voucher details?";
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;

// "Send us a query" routes to the public contact page.
const QUERY_LINK = "/contact";

// Drop the WhatsApp QR image here (public folder). Falls back gracefully if absent.

const STATS = [
  { icon: <HiSparkles />, value: "AI-Powered", label: "Accurate AI Scoring" },
  { icon: <FiUsers />, value: "50,000+", label: "Successful Students" },
  { icon: <FiStar />, value: "4.8", label: "2,700+ Ratings" },
];

const PteVoucherPopup = ({ show, onClose }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdropClassName="pte-voucher-backdrop"
      dialogClassName="pte-voucher-dialog"
      contentClassName="pte-voucher-content"
    >
      <div className="pte-voucher">
        <span className="pte-voucher__glow" aria-hidden="true" />
        <span className="pte-voucher__hairline" aria-hidden="true" />

        <button
          type="button"
          className="pte-voucher__close"
          aria-label="Close"
          onClick={onClose}
        >
          <FiX />
        </button>

        <div className="pte-voucher__body">
          <img className="pte-voucher__logo" src={voucherLogo} alt="LA Language Academy" />

          <div className="pte-voucher__heading">
            <h2 className="pte-voucher__title">
              Book Your PTE Exam For <span className="accent">₹2,500 Less</span>
            </h2>
            <p className="pte-voucher__subtitle">
              Official PTE Academic exam voucher at a limited-time price — plus 20% off our
              AI practice plans and online classes.
            </p>
          </div>

          {/* Price card */}
          <div className="pte-voucher__price-card">
            <div className="pte-voucher__price-row">
              <div className="pte-voucher__price-main">
                <span className="pte-voucher__price-old">₹18,900</span>
                <span className="pte-voucher__price-new">₹16,400</span>
              </div>
              <span className="pte-voucher__save">
                <FiCheck className="pte-voucher__save-tick" />
                Save ₹2,500
              </span>
            </div>
            <div className="pte-voucher__price-note">
              <FiCheckCircle className="pte-voucher__price-note-icon" />
              <span>Official PTE Academic voucher · valid for exams in India only</span>
            </div>
          </div>

          {/* Bonus */}
          <div className="pte-voucher__bonus">
            <FiGift className="pte-voucher__bonus-icon" />
            <p>
              Bonus, free with every voucher: 20% off any Language Academy AI practice plan
              and online classes.
            </p>
          </div>

          {/* Stats */}
          <div className="pte-voucher__stats-wrap">
            <div className="pte-voucher__stats">
              {STATS.map((stat) => (
                <div className="pte-voucher__stat" key={stat.value}>
                  <span className="pte-voucher__stat-icon">{stat.icon}</span>
                  <div className="pte-voucher__stat-text">
                    <span className="pte-voucher__stat-value">{stat.value}</span>
                    <span className="pte-voucher__stat-label">{stat.label}</span>
                  </div>
                </div>
              ))}
            </div>
            <span className="pte-voucher__badge">
              <span className="pte-voucher__badge-dot" />
              LIMITED TIME OFFER
            </span>
          </div>

          <div className="pte-voucher__divider" />

          {/* Claim row */}
          <div className="pte-voucher__claim">
            <div className="pte-voucher__qr-col">
              <div className="pte-voucher__qr">
                <img src={voucherQr} alt="Scan to claim on WhatsApp" />
              </div>
              <div className="pte-voucher__phone">
                <FiPhoneCall className="pte-voucher__phone-icon" />
                <span>+91 90566 11913</span>
              </div>
            </div>

            <div className="pte-voucher__action-col">
              <p className="pte-voucher__action-lead">
                Scan the code with your phone, or tap below
              </p>
              <a
                className="pte-voucher__cta"
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp className="pte-voucher__cta-wa" />
                Claim on WhatsApp
                <FiArrowUpRight className="pte-voucher__cta-arrow" />
              </a>

              <div className="pte-voucher__divider pte-voucher__divider--soft" />

              <div className="pte-voucher__trust">
                <span>Secure Payments</span>
                <span className="pte-voucher__trust-dot">·</span>
                <span>No Hidden Fees</span>
                <span className="pte-voucher__trust-dot">·</span>
                <span>Real Human Support</span>
              </div>

              <div className="pte-voucher__divider pte-voucher__divider--soft" />

              <a className="pte-voucher__query" href={QUERY_LINK} target="_blank" rel="noopener noreferrer">
                Prefer to enquire online? Send us a query →
              </a>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PteVoucherPopup;
